import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  error: null,
  paymentMethods: [],
  gateways: []
};

const balanceSlice = createSlice({
  name: 'balance',
  initialState,
  reducers: {
    // General loading and error handling actions
    requestStart: state => {
      state.isLoading = true;
      state.error = null;
    },
    requestFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    // Payment methods - GET
    getPaymentMethodsSuccess: (state, action) => {
      state.paymentMethods = action.payload.content;
      state.isLoading = false;
    },

    // Payment methods - PUT
    updatePaymentMethodSuccess: (state, action) => {
      state.paymentMethods = state.paymentMethods.map(paymentMethod =>
        paymentMethod.id === action.payload.id
          ? { ...action.payload }
          : paymentMethod
      );
      state.isLoading = false;
    },

    // Payment methods - POST
    createPaymentMethodSuccess: (state, action) => {
      state.paymentMethods = [...state.paymentMethods, action.payload.data];
      state.isLoading = false;
    },

    // Gateways - GET
    getGatewaysSuccess: (state, action) => {
      state.gateways = action.payload.data.content;
      state.isLoading = false;
    },

    // Gateways - POST
    createGatewaySuccess: (state, action) => {
      state.gateways = [...state.gateways, action.payload.data.content];
      state.isLoading = false;
    }
  }
});

export const {
  requestStart,
  requestFailure,
  getPaymentMethodsSuccess,
  updatePaymentMethodSuccess,
  createPaymentMethodSuccess,
  getGatewaysSuccess,
  createGatewaySuccess
} = balanceSlice.actions;

export default balanceSlice.reducer;
